
(function() {
  var result = { translations: { "pl": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Alba\u0144ski", "sq-al": "Alba\u0144ski (Albania)", "ar": "Arabski", "ar-dz": "Arabski (Algieria)", "ar-bh": "Arabski (Bahrajn)", "ar-eg": "Arabski (Egipt)", "ar-iq": "Arabski (Irak)", "ar-jo": "Arabski (Jordania)", "ar-kw": "Arabski (Kuwejt)", "ar-lb": "Arabski (Liban)", "ar-ly": "Arabski (Libia)", "ar-ma": "Arabski (Maroko)", "ar-om": "Arabski (Oman)", "ar-qa": "Arabski (Katar)", "ar-sa": "Arabski (Arabia Saudyjska)", "ar-sd": "Arabski (Sudan)", "ar-sy": "Arabski (Syria)", "ar-tn": "Arabski (Tunezja)", "ar-ae": "Arabski (Zjednoczone Emiraty Arabskie)", "ar-ye": "Arabski (Jemen)", "as": "Asamski", "az": "Azerbejd\u017Ca\u0144ski", "hy": "Ormia\u0144ski", "eu": "Baskijski", "be": "Bia\u0142oruski", "be-by": "Bia\u0142oruski (Bia\u0142oru\u015B)", "bn": "Bengalski", "bg": "Bu\u0142garski", "bg-bg": "Bu\u0142garski (Bu\u0142garia)", "bs": "Bo\u015Bniacki", "ca": "Katalo\u0144ski", "ca-es": "Katalo\u0144ski (Katalonia)", "zh": "Chi\u0144ski", "zh-cn": "Chi\u0144ski (uproszczony)", "zh-hk": "Chi\u0144ski (Hongkong)", "zh-mo": "Chi\u0144ski (Makau)", "zh-sg": "Chi\u0144ski (Singapur)", "zh-tw": "Chi\u0144ski (tradycyjny)", "zh-chs": "Chi\u0144ski (uproszczony)", "zh-cht": "Chi\u0144ski (tradycyjny)", "zh-hans": "Chi\u0144ski (uproszczony han)", "zh-hant": "Chi\u0144ski (tradycyjny han)", "hr": "Chorwacki", "hr-hr": "Chorwacki (Chorwacja)", "cs": "Czeski", "cs-cz": "Czeski (Czechy)", "da": "Du\u0144ski", "da-dk": "Du\u0144ski (Du\u0144ski)", "nl": "Niderlandzki", "nl-be": "Holenderski (Belgia)", "nl-ch": "Holenderski (Szwajcaria)", "nl-lu": "Niderlandzki (Luksemburg)", "nl-nl": "Holenderski (Holandia)", "en": "Angielski", "en-ae": "Angielski (Zjednoczone Emiraty Arabskie)", "en-au": "Angielski (Australia)", "en-be": "Angielski (Belgia)", "en-ca": "Angielski (Kanada)", "en-ch": "Angielski (Szwajcaria)", "en-cn": "Angielski \u2014 Chiny", "en-de": "Angielski (Niemcy)", "en-ee": "Angielski - Estonia", "en-es": "Angielski (Hiszpania)", "en-fr": "Angielski - Francja", "en-hk": "Angielski (Hong Kong)", "en-in": "Angielski (Indie)", "en-ie": "Angielski (Irlandia)", "en-ke": "Angielski \u2014 Kenia", "en-lu": "Angielski (Luksemburg)", "en-my": "Angielski (Malezja)", "en-mt": "Angielski (Malta)", "en-mx": "Angielski (Meksyk)", "en-nl": "Angielski \u2014 Niderlandy", "en-nz": "Angielski (Nowa Zelandia)", "en-ph": "Angielski (Filipiny)", "en-pk": "Angielski (Pakistan)", "en-se": "Angielski - Szwecja", "en-sg": "Angielski (Singapur)", "en-tn": "Angielski (Tunezja)", "en-za": "Angielski (RPA)", "en-gb": "Angielski (Wielka Brytania)", "en-us": "Angielski (Stany Zjednoczone)", "en-zw": "Angielski (Zimbabwe)", "et": "Esto\u0144ski", "et-ee": "Esto\u0144ski (Estonia)", "fo": "Farerski", "fa": "Perski", "fi": "Fi\u0144ski", "fi-fi": "Fi\u0144ski (Finlandia)", "fil": "Filipi\u0144ski", "fr": "Francuski", "fr-be": "Francuski (Belgia)", "fr-ca": "Francuski (Kanada)", "fr-fr": "Francuski (Francja)", "fr-lu": "Francuski (Luksemburg)", "fr-mc": "Francuski (Monako)", "fr-ch": "Francuski (Szwajcaria)", "fr-tn": "Francuski \u2014 Tunezja", "gl": "Galicyjski", "ka": "Gruzi\u0144ski", "de": "Niemiecki", "de-at": "Niemiecki (Austria)", "de-de": "Niemiecki (Niemcy)", "de-gr": "Niemiecki (Grecja)", "de-li": "Niemiecki (Liechtenstein)", "de-lu": "Niemiecki (Luksemburg)", "de-ch": "Niemiecki (Szwajcaria)", "el": "Grecki", "el-cy": "Grecki (Cypr)", "el-gr": "Grecki (Grecja)", "gu": "Gud\u017Aarati", "haw": "Hawajski", "ha": "Hausa", "he": "Hebrajski", "he-il": "Hebrajski (Izrael)", "iw-il": "Hebrajski (Izrael)", "hi": "Hindi", "hi-in": "Hindi (Indie)", "hu": "W\u0119gierski", "hu-hu": "W\u0119gierski (W\u0119gry)", "is": "Islandzki", "is-is": "Islandzki (Islandia)", "id": "Indonezyjski", "in-id": "Indonezyjski (Indonezja)", "ga": "Irlandzki", "ga-ie": "Irlandzki (Irlandia)", "it": "W\u0142oski", "it-it": "W\u0142oski (W\u0142ochy)", "it-ch": "W\u0142oski (Szwajcaria)", "ja": "Japo\u0144ski", "ja-jp": "Japo\u0144ski (Japonia)", "kn": "Kannada", "kk": "Kazachski", "kok": "Konkani", "ko": "Korea\u0144ski", "ko-kr": "Korea\u0144ski (Korea Po\u0142udniowa)", "ku": "Kurdyjski", "ky": "Kirgiski", "ky-kg": "Kirgiski", "lo": "Laota\u0144ski", "lv": "\u0141otewski", "lv-lv": "\u0141otewski (\u0141otwa)", "lt": "Litewski", "lt-lt": "Litewski (Litwa)", "mk": "Macedo\u0144ski", "mk-mk": "Macedo\u0144ski (Macedonia)", "ml": "Malajalam", "ms": "Malajski", "ms-bn": "Malajski (Brunei)", "ms-my": "Malajski (Malezja)", "mt": "Malta\u0144ski", "mt-mt": "Malta\u0144ski (Malta)", "mr": "Marathi", "mn": "Mongolski", "my": "Birma\u0144ski", "my-mm": "Birma\u0144ski (Mjanma)", "ne": "Nepalczycy", "no": "Norweski", "nb": "Norweski Bokmal", "nb-no": "Norweski Bokmal - Norwegia", "no-no": "Norweski (Norwegia)", "pl": "Polski", "pl-pl": "Polski (Polska)", "pt": "Portugalski", "pt-br": "Portugalski (Brazylia)", "pt-pt": "Portugalski (Portugalia)", "pa": "Pend\u017Cabski", "pa-in": "Punjabi \u2014 Indie", "pa-pk": "Punjabi \u2014 Pakistan", "ro": "Rumu\u0144ski", "ro-ro": "Rumu\u0144ski (Rumunia)", "ru": "Rosyjski", "ru-ru": "Rosyjski (Rosja)", "rw-rw": "Kinyarwanda", "sa": "Sanskryt", "si": "Sinhala", "sr": "Serbski", "sr-ba": "Serbski (Bo\u015Bnia i Hercegowina)", "sr-me": "Serbski (Czarnog\xF3ra)", "sr-rs": "Serbski (Serbia)", "sr-cs": "Serbski (dawniej Serbia i Czarnog\xF3ra)", "sk": "S\u0142owacki", "sk-sk": "S\u0142owacki (S\u0142owacja)", "sl": "S\u0142owe\u0144ski", "sl-si": "S\u0142owe\u0144ski (S\u0142owenia)", "es": "Hiszpa\u0144ski", "es-ar": "Hiszpa\u0144ski (Argentyna)", "es-bo": "Hiszpa\u0144ski (Boliwia)", "es-cl": "Hiszpa\u0144ski (Chile)", "es-co": "Hiszpa\u0144ski (Kolumbia)", "es-cr": "Hiszpa\u0144ski (Kostaryka)", "es-cu": "Hiszpa\u0144ski (Kuba)", "es-do": "Hiszpa\u0144ski (Dominikana)", "es-ec": "Hiszpa\u0144ski (Ekwador)", "es-sv": "Hiszpa\u0144ski (Salwador)", "es-gt": "Hiszpa\u0144ski (Gwatemala)", "es-hn": "Hiszpa\u0144ski (Honduras)", "es-mx": "Hiszpa\u0144ski (Meksyk)", "es-ni": "Hiszpa\u0144ski (Nikaragua)", "es-pa": "Hiszpa\u0144ski (Panama)", "es-py": "Hiszpa\u0144ski (Paragwaj)", "es-pe": "Hiszpa\u0144ski (Peru)", "es-pr": "Hiszpa\u0144ski (Portoryko)", "es-es": "Hiszpa\u0144ski (Hiszpania)", "es-us": "Hiszpa\u0144ski (Stany Zjednoczone)", "es-uy": "Hiszpa\u0144ski (Urugwaj)", "es-ve": "Hiszpa\u0144ski (Wenezuela)", "sw": "Suahili", "sv": "Szwedzki", "sv-fi": "Szwedzki (Finlandia)", "sv-se": "Szwedzki (Szwecja)", "sy": "Syryjski", "ta": "Tamilski", "tt": "Tatarski", "te": "Telugu", "th": "Tajski", "th-th": "Tajski (Tajlandia)", "tl": "Tagalski", "tr": "Turecki", "tr-tr": "Turecki (Turcja)", "uk": "Ukrai\u0144ski", "uk-ua": "Ukrai\u0144ski (Ukraina)", "ur": "Urdu", "uz": "Uzbecki", "vi": "Wietnamski", "vi-vn": "Wietnamski (Wietnam)", "yi": "Jidysz", "zu": "Zuluski" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "pl": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }}min", "hours": "{{ hours }} godz.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} godz.", "days": "{{ days }} dn.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, rozsz. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pl": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pl', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "pl": { "videoPlayer": { "htmlTitle": "Film HubSpot", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Video", "controls": { "audioPlayer": "Odtwarzacz d\u017Awi\u0119ku", "videoPlayer": "Odtwarzacz wideo", "play": "Odtw\xF3rz", "playVideo": "Odtw\xF3rz wideo", "pause": "Wstrzymaj", "replay": "Powt\xF3rz", "currentTime": "Bie\u017C\u0105cy czas", "duration": "Czas trwania", "remainingTime": "Pozosta\u0142y czas", "fullscreen": "Pe\u0142ny ekran", "exitFullscreen": "Opu\u015B\u0107 pe\u0142ny ekran", "mute": "Wycisz", "unmute": "Wy\u0142\u0105cz wyciszenie", "volumeLevel": "Poziom g\u0142o\u015Bno\u015Bci", "captions": "Napisy", "captionsOff": "Wy\u0142.", "seekBar": "Dostosuj pozycj\u0119", "chapter": "Rozdzia\u0142", "elapsedTime": "Czas, kt\xF3ry up\u0142yn\u0105\u0142: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Opcje odtwarzania", "playbackRate": "Pr\u0119dko\u015B\u0107 odtwarzania:", "quality": "Jako\u015B\u0107:", "normal": "Normalna", "auto": "(Automatyczna)" }, "formModal": { "defaultThankYouMessage": "Dzi\u0119kujemy za odpowied\u017A!", "inlineMessageButton": "Obejrzyj wideo" }, "ctaModal": { "imgAlt": "Wezwanie do dzia\u0142ania \u2013 wideo" }, "errors": { "generic": { "heading": "Nie mo\u017Cna za\u0142adowa\u0107 pliku wideo" }, "UNAUTHORIZED": { "heading": "Nie w\u0142\u0105czono wideo" }, "VIDEO_NOT_FOUND": { "heading": "Nie odnaleziono pliku wideo" }, "INVALID_URL": { "heading": "Nie odnaleziono pliku wideo" }, "UNSUPPORTED_EMBED": { "heading": "Film niedost\u0119pny", "extra": "Film nie mo\u017Ce zosta\u0107 wy\u015Bwietlony zewn\u0119trznie." }, "refreshLink": "Spr\xF3buj ponownie" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "pl": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:pl', {version: 'static-1.29208'}); }
})();


